import { render, staticRenderFns } from "./ConsultarCarona.vue?vue&type=template&id=19663898&scoped=true"
import script from "./ConsultarCarona.vue?vue&type=script&lang=js"
export * from "./ConsultarCarona.vue?vue&type=script&lang=js"
import style0 from "./ConsultarCarona.vue?vue&type=style&index=0&id=19663898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19663898",
  null
  
)

export default component.exports